// extracted by mini-css-extract-plugin
module.exports = {"country":"PhoneInput_country__MQarB","countryMenu":"PhoneInput_countryMenu__m91Sn","number":"PhoneInput_number__Xepti","countryLabel":"PhoneInput_countryLabel__7Vlcs"};